module.exports = __webpack_public_path__ + "img/JOR.be07fca7.svg";